import { useAppSelector } from "@/shared/hooks";
import styles from "./UserInfo.module.scss";
import { MailingSettings, UserMainInfo, UserReviewForm } from "@/features";
import { useState } from "react";
import clsx from "clsx";

export const UserInfo = () => {
  const { userForReview } = useAppSelector((state) => state.users);
  const { roleName } = useAppSelector((state) => state.viewer);

  const [viewMode, setViewMode] = useState<"info" | "subs">("info");

  return (
    <>
      {userForReview && (
        <div className={styles.userInfoWrapper}>
          <UserMainInfo user={userForReview} />
          {roleName === "Dealer" && (
            <div className={styles.switcherRow}>
              <div className={styles.switcherType}>
                <div
                  onClick={() => setViewMode("info")}
                  className={clsx(styles.switcherTab, {
                    [styles.activeTab]: viewMode === "info",
                  })}
                >
                  Мои данные
                </div>
                <div
                  onClick={() => setViewMode("subs")}
                  className={clsx(styles.switcherTab, {
                    [styles.activeTab]: viewMode === "subs",
                  })}
                >
                  Подписка на рассылки
                </div>
              </div>
            </div>
          )}

          {viewMode === "subs" && roleName === "Dealer" ? (
            <MailingSettings
              userId={userForReview.id}
              dealerId={userForReview.dealerId}
            />
          ) : (
            <UserReviewForm user={userForReview} />
          )}
        </div>
      )}
    </>
  );
};
